import axios from "axios";
import { getPreferredLanguage } from "../../../helpers";
import { generateHash, generateMinifiedQuery } from "../../../Graphql/hash";
var tveProviderListQuery = "query ($device: Device!, $domain: String, $siteId: String, $country: String, $language: String) {\n  bootstrap(device: $device, domain: $domain, siteId: $siteId, country: $country, language: $language) {\n    appcmsPlatform {\n      tveSettings {\n        \n        providers\n        {\n          identifier\n          imageUrl\n          logoUrl\n          title\n          fwIdentifier\n        }\n      }\n    }\n    \n  }\n}";
var minifiedTveQuery = generateMinifiedQuery(tveProviderListQuery);
var minifiedTveQuerySHA = generateHash(minifiedTveQuery);
export function getTveProviderList() {
    var _a, _b, _c;
    var baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseCachedUrl;
    var endpoint = "".concat(baseUrl, "/graphql");
    var variables = {
        "domain": location.host,
        "device": "WEB",
        "country": null,
        "language": getPreferredLanguage() || 'en'
    };
    return axios.get(endpoint + '?extensions={"persistedQuery":{"version":1,"sha256Hash":' + JSON.stringify(minifiedTveQuerySHA) + '}}&variables=' + JSON.stringify(variables))
        .then(function (response) {
        var data = response.data;
        if (data.errors) {
            return {
                "error": true
            };
        }
        else {
            return data;
        }
    })
        .catch(function (err) { return console.log("Error: ".concat(err), "error"); });
}
